import React, { useState } from 'react';
import { ConfigProvider } from 'antd';
import Sidebar from './components/Sidebar';
import ProblemGoalIntelligence from './components/topics/ProblemGoalIntelligence';
import SearchMethods from './components/topics/SearchMethods';
import DataInformationKnowledge from './components/topics/DataInformationKnowledge';
import AIApproaches from './components/topics/AIApproaches';
import ModelTraining from './components/topics/ModelTraining';
import LearningTechniques from './components/topics/LearningTechniques';
import ReinforcementLearning from './components/topics/ReinforcementLearning';
import ConvolutionalNeuralNetwork from './components/topics/ConvolutionalNeuralNetwork';
import ModelTypes from './components/topics/ModelTypes';
import RAG from './components/topics/RAG';
import DiffusionExplainer from './components/topics/DiffusionExplainer';
import TransformersExplained from './components/topics/Transformers';
import GANExplainer from './components/topics/GANExplainer';
import VAEExplainer from './components/topics/VAEExplainer';
import NeuralNetworkExplorer from './components/topics/NeuralNetworkExplorer';

import 'antd/dist/reset.css';
import './App.css';
import AgenticAI from './components/topics/AgenticAI';
import AIvsML from './components/topics/AIvsML';
import AIEthics from './components/topics/AIEthics';
import SpaceDodgeGame from './components/games/SpaceDodgeGame';
import BalloonPopGame from './components/games/BalloonGame';
import BoxingGame from './components/games/BoxingGame';
import StepRunner from './components/games/StepRunner';
import MathBubblePop from './components/games/MathBubblePop';
import DodgeBall from './components/games/DodgeBall';
import TwoPlayerDodgeball from './components/games/DodgeBallTwoPlayer';
import SpeedOfLight from './components/games/SpeedOfLight';
import RedLightGreenLight from './components/games/RedLightGreenLight';

function App() {
  const [activeTopic, setActiveTopic] = useState(0);
  
  const topics = [
    { id: 0, name: "Problem, Goal, Intelligence", component: ProblemGoalIntelligence },
    { id: 1, name: "Data, Information, Knowledge", component: DataInformationKnowledge },
    { id: 2, name: "Search Methods", component: SearchMethods },
    { id: 3, name: "AI Approaches", component: AIApproaches },
    { id: 4, name: "AI vs ML", component: AIvsML },
    { id: 5, name: "Model Training", component: ModelTraining },
    { id: 6, name: "Learning Techniques", component: LearningTechniques },
    { id: 7, name: "Reinforcement Learning", component: ReinforcementLearning },
    { id: 8, name: "Model Types", component: ModelTypes },
    { id: 9, name: "Neural Network", component: NeuralNetworkExplorer },
    { id: 10, name: "Transformers", component: TransformersExplained },
    { id: 11, name: "CNNs", component: ConvolutionalNeuralNetwork },
    { id: 12, name: "RAG", component: RAG },
    { id: 13, name: "VAEs", component: VAEExplainer },
    { id: 14, name: "GANs", component: GANExplainer },
    { id: 15, name: "Diffusion Models", component: DiffusionExplainer },
    { id: 16, name: "Agentic AI", component: AgenticAI },
    { id: 17, name: "AI Ethics", component: AIEthics },
    { id: 18, name: "Two Player Dodge Ball Game", component: TwoPlayerDodgeball },
    // { id: 19, name: "SpaceDodge Game", component: SpaceDodgeGame },
    // { id: 20, name: "Balloon Game", component: BalloonPopGame },
    // { id: 21, name: "Boxing Game", component: BoxingGame },
    // { id: 22, name: "Step Runner Game", component: StepRunner },
    // { id: 23, name: "Bubble Pop Game", component: MathBubblePop },
    // { id: 24, name: "Dodge Ball Game", component: DodgeBall },
    // { id: 25, name: "Red Light Green Light Game", component: RedLightGreenLight },
    // { id: 26, name: "Speed of Light Game", component: SpeedOfLight },
  ];

  const ActiveComponent = topics[activeTopic].component;

  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
          colorPrimary: '#0071e3',
          borderRadius: 8,
        },
      }}
    >
      <div className="app">
        <Sidebar 
          topics={topics} 
          activeTopic={activeTopic} 
          setActiveTopic={setActiveTopic} 
        />
        <main className="main-content">
          <ActiveComponent />
        </main>
      </div>
    </ConfigProvider>
  );
}

export default App;